<template>
  <post-sign-promo v-if="isMounted"/>
</template>

<script setup lang="ts">
import {defineAsyncComponent, ref, watch} from 'vue';

import {usePostSignPromo} from '../model/usePostSignPromo';

// Картинки промо весят больше самого диалога, поэтому чанк подгружаем только тогда,
// когда промо действительно решили показать.
const PostSignPromo = defineAsyncComponent(() => import('./PostSignPromo.vue'));

const {isOpen} = usePostSignPromo();

const isMounted = ref<boolean>(false);

// Обратно в false не возвращаем: снять компонент в момент закрытия — значит оборвать
// анимацию диалога, а один смонтированный диалог ничего не стоит.
watch(isOpen, (val: boolean) => {
  if (val) isMounted.value = true;
}, {immediate: true});
</script>
